module.exports = __webpack_public_path__ + "img/missionaries16_2019_7-7-2021.b28d713f.jpg";